<template>
  <div class="flex flex-row">
    <button v-if="currentPage !== 1" class="px-2" @click="updatePage(currentPage - 1)">Vorige</button>
    <button v-for="n in lastPage" :key="n" class="px-2" :class="{'font-bold border-b': n === currentPage}" @click="updatePage(n)">{{ n }}</button>
    <button v-if="currentPage !== lastPage" class="px-2" @click="updatePage(currentPage + 1)">Volgende</button>
  </div>
</template>

<script>
export default {
  props: {
    lastPage: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    updatePage(page) {
      this.$emit('input', page);
    },
  },
};
</script>
